export default __webpack_public_path__ + "static/marketing_2-1e5ff9e7f2b06a7b9857b46503b89941.png";